import { callGetLegacyRoute } from 'utils/routing';
const baseUrl = '/email/';

export default {
    /**
     * Call to the back for validate connexion with provider
     *
     * @param {Object} formData data to validate
     * @param {*} params to pass in query
     * @return {promise}
     */
    validateSignIn(formData, params = {}) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(
                `/`,
                params,
                formData,
                (res) => resolve(res),
                (err) => reject(err.response.data.error.message),
            );
        });
    },
    /**
     * Call to the legacy back for init onboarding email
     *
     * @return {promise}
     */
    initValidateOnboardingEmail() {
        return callGetLegacyRoute({ _f: 'prefsNylas', action: 'login' });
    },
    /**
     * Call to the legacy back for validate step
     *
     * @return {promise}
     */
    validateOnboardingEmailStep(step, options = {}) {
        return callGetLegacyRoute({
            _f: 'onboarding',
            action: 'email',
            step,
            ...options,
        });
    },

    /**
     * Call to the API to find all dns linked to email passed in param
     *
     * @param {*} params
     * @return {promise}
     */
    findDns(params = {}) {
        return new Promise((resolve, reject) => {
            ApiClient.get(`/email/authenticate`, params)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err.response.data.error.message));
        });
    },
    /**
     * Check if is a valid authenticated domain with valid property of Dns result.
     *
     * @param {*} email required to call api
     * @return {promise} return a boolean promise
     */
    validateDomainAuth(email) {
        return this.findDns({ email }).then(({ valid }) => !!valid);
    },

    /**
     * Force the auth of the domain
     *
     * @param {*} data required to call api
     * @return {promise} return a boolean promise
     */
    authDomainValidation(data = {}) {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-undef
            ApiClient.post(`/email/domain/validate`, {}, data)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err.response.data.error.message));
        });
    },

    validateEmail(email) {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-undef
            ApiClient.post(baseUrl + 'verification/validate', {}, { email })
                .then((response) => resolve(response.data))
                .catch((error) => reject(error.response.data.error));
        });
    },

    sendVerificationEmail(email, redirect_uri = null) {
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-undef
            ApiClient.post(baseUrl + 'verification/send', {}, { email, redirect_uri })
                //response with no content
                .then((response) => resolve(response))
                .catch((error) => reject(error.response.data.error));
        });
    },
};
